import React, {Fragment} from 'react'
import imagesPath from '../config/imagesPath';


const MobileLayout = () => {
    return (
        <Fragment>
            <div className="container" data-aos="fade-up">
                <section className="about">
                    <div className="section-titles">
                        <h3 className="heading_tow">What we do</h3>
                    </div>
                    <div className="row">
                        <div
                            className="col-lg-8 col-md-8 pt-lg-0 content d-flex flex-column justify-content-center text-right"
                            data-aos="fade-up" data-aos-delay="100">
                            <div style={{
                                display: "flex"
                            }}> <span
                                style={{
                                    alignItems: "center",
                                    display: "flex"
                                }}> <h3 className='text-align'> Financing independent commercial EV drivers </h3></span>
                                <span className='mobile-view-img'>  <img src={imagesPath.img2}
                                                                         className="img-fluid imgborder"
                                                                         alt="Pictorial Representation of Business model"

                                />
                  <div className="gray-bgcolor"></div>
                  <div className="blue-bgcolor"></div>
                </span></div>

                        </div>

                        <div className="col-lg-4 col-md-4  mb-15 padding-top-auto" data-aos="fade-right"
                             data-aos-delay="100">
                            <p className="blue-color content-info">
                                Revfin is a technology company. It's subsidiary company (Aristo Securities Private
                                Limited, an NBFC) provides loans to independent drivers who buy and operate passenger or
                                cargo electric vehicles for last mile connectivity. Partnerships with EV manufacturers
                                and dealerships Pan-India to provide point of sale financing.
                            </p>
                        </div>

                    </div>

                </section>
            </div>


            {/* <!-- End About Section -->

<!-- ======= About Section ======= --> */}

            <div className="container" data-aos="fade-up">
                <section className="about">
                    <div className="row">
                        <div
                            className="col-lg-8 col-md-8 pt-4 pt-lg-0 content d-flex flex-column justify-content-center text-left order-md-2 "
                            data-aos="fade-right" data-aos-delay="100">
                            <div style={{
                                display: "flex"
                            }}
                            > <span className='mobile-view-img'>  <img src={imagesPath.img3}
                                                                       className="img-fluid imgborder" alt=""
                            />
                  <div className="gray-bgcolor"></div>
                  <div className="blue-bgcolor"></div>
                </span>
                                <span
                                    style={{
                                        alignItems: "center",
                                        display: "flex"
                                    }}> <h3
                                    className='text-align'>Driver cum Owner (DCO) fleet vehicle operators</h3></span>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-4 mb-15 padding-top-bike order-md-1 " data-aos="fade-up"
                             data-aos-delay="100">
                            <p className="blue-color content-info">
                                Revfin is a technology company. It's subsidiary company (Aristo Securities Private
                                Limited, an NBFC) provides loan or Lease to drivers who buy and operate passenger or
                                cargo electric vehicles for last mile connectivity through E-commerce, Fleet operators &
                                logistics company.</p>
                        </div>


                    </div>

                </section>
            </div>
        </Fragment>
    )
}

export default MobileLayout;



// WEBPACK FOOTER //
// ./src/components/MobileLayout.js